import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
export function formatPercent(formatter, value, maximumFractionDigits) {
  if (typeof maximumFractionDigits !== 'undefined' && maximumFractionDigits !== null) {
    return formatter.percent(value, {
      maximumFractionDigits
    });
  } else {
    return formatter.percent(value);
  }
}
// eslint-disable-next-line ember/no-classic-classes
export default Helper.extend({
  formatter: service(),
  compute([value, maximumFractionDigits]) {
    return formatPercent(this.formatter, value, maximumFractionDigits);
  }
});